import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Tooltip } from "primereact/tooltip";

import "./SidebarItemCollapsed.scss";

const SidebarItemCollapsed = ({
    id,
    path,
    icon,
    header,
    activeIcon,
    child,
    activeMenuItem,
    setActiveMenuItem,
}) => {
    const handleIconClick = () => {
        if (activeMenuItem === id) {
            setActiveMenuItem(-1);
        } else {
            setActiveMenuItem(id);
            if (!isActive) {
                setActiveSubMenuItem(-1);
            }
        }
    };

    const { pathname } = useLocation();
    const [isActive, setIsActive] = useState(false);
    const [activeSubMenuItem, setActiveSubMenuItem] = useState(-1);

    const handleSubIconClick = (key) => {
        if (activeSubMenuItem === key) {
            setActiveSubMenuItem(-1);
        } else {
            setActiveSubMenuItem(key);
        }
    };

    useEffect(() => {
        setIsActive(pathname.includes(path));
    }, [pathname]);

    return (
        <div className="sidebar-item-collapsed-container">
            <Tooltip target=" .sidebar-item-collapsed-label "  position="right" />      
            {child.length === 0 ? (
                <NavLink to={path} className="sidebar-item-collapsed-label"  data-pr-tooltip={header} data-pr-classname="blue-tooltip"	>
                    {isActive ? activeIcon : icon}
                </NavLink>
            ) : (
                <div
                    className={`sidebar-item-collapsed-label ${
                        isActive ? "active" : ""
                    }`}
                    onClick={handleIconClick}
                    data-pr-tooltip={header}
                    data-pr-classname="blue-tooltip"
                >
                    {isActive ? activeIcon : icon}
                    <i className="pi pi-caret-down" />
                </div>
            )}
            {activeMenuItem === id && (
            <div className="collapsed-list-item">
                {child.map((childNav) => (
                    childNav.child.length === 0 ? (
                        <NavLink
                            key={childNav.key}
                            to={childNav.path}
                            className={
                                pathname.includes(childNav.path) ? "active" : ""
                            }
                        >
                            {childNav.header}
                        </NavLink>
                    ) : (
                        <div
                        className="child-nav-item"
                        key={childNav.key}
                        >
                        <div 
                        className={`child-nav-item-header ${pathname.includes(childNav.path) ? "active" : ""}`}
                        >
                        <span>{childNav.header}</span>
                        <i
                            className={`pi ${
                                activeSubMenuItem === childNav.key
                                    ? "pi-angle-up"
                                    : "pi-angle-down"
                            }`}
                            onClick={() => handleSubIconClick(childNav.key)}
                            data-testid={`expand-icon-${childNav.key}`}
                        />
                        </div>
                        {activeSubMenuItem === childNav.key && (
                                    <div className="nested-child-nav">
                                        {childNav.child.map((nestedChild) => (
                                            <NavLink
                                                key={nestedChild.key}
                                                to={nestedChild.path}
                                                className={
                                                    pathname.includes(
                                                        nestedChild.path
                                                    )
                                                        ? "active"
                                                        : ""
                                                }
                                            >
                                                {nestedChild.header}
                                            </NavLink>
                                        ))}
                                    </div>
                        )}
                        </div>
                        )
                ))}
            </div>
        )}
        </div>
    );
};

export default SidebarItemCollapsed;
